import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

export const FAQ = () => {
  const faqs = [
    {
      id: '1',
      question: 'Eu preciso pagar alguma coisa adiantado?',
      answer: 'Não, nada! Você não tira nenhum centavo do bolso para conversar com a gente nem para entrar com o processo. A gente só recebe uma porcentagem combinada se e quando você ganhar o dinheiro. Se você não receber nada, não paga nada pra gente.',
    },
    {
      id: '2',
      question: 'Meu nome vai ficar "queimado" para arrumar outro emprego?',
      answer: 'Não! Isso é história que patrão espalha pra botar medo. Não existe lista com nome de quem processou empresa. A lei proíbe qualquer lugar de recusar funcionário por causa disso.',
    },
    {
      id: '3',
      question: 'Saí da empresa faz tempo. Ainda dá tempo de cobrar?',
      answer: 'Se você saiu faz menos de 2 anos, dá tempo sim! Pela lei, dá pra cobrar tudo o que deixaram de te pagar nos últimos 5 anos de trabalho. Mas não demore, porque depois de 2 anos você perde o direito pra sempre.',
    },
    {
      id: '4',
      question: 'Trabalhei sem carteira ou como MEI. Tenho direitos?',
      answer: 'Tem sim, todos eles! O que manda na Justiça é o que acontecia de verdade: se você tinha horário e recebia ordens de chefe, eles são obrigados a pagar seu FGTS, 13º, férias e a assinar sua carteira.',
    },
    {
      id: '5',
      question: 'Quanto tempo demora pra sair o dinheiro?',
      answer: 'Muitas empresas preferem fazer acordo rápido logo na primeira conversa com o juiz (em 2 a 4 meses). Se não tiver acordo e o juiz tiver que julgar, leva mais tempo, mas o valor vai subindo com juros todo mês.',
    },
    {
      id: '6',
      question: 'Vou ter que ficar cara a cara com meu ex-chefe?',
      answer: 'Quase nunca! Hoje quase todas as audiências são feitas pela internet, pelo próprio celular, no conforto da sua casa. E o nosso advogado entra junto com você na chamada pra falar e te defender em tudo.',
    },
    {
      id: '7',
      question: 'Que documentos eu preciso ter em mãos?',
      answer: 'O básico que você tiver: RG, CPF, carteira de trabalho (pode ser a digital do celular) e o extrato do FGTS. Se tiver mensagens de WhatsApp, fotos ou e-mails, ajuda muito. Se faltar algum papel, a gente te ajuda a achar.',
    },
    {
      id: '8',
      question: 'Como eu recebo o dinheiro no final?',
      answer: 'Direto na sua conta bancária. Quando a empresa pagar na Justiça, o valor é liberado, descontamos a porcentagem do nosso trabalho e o restante vai direto pra você.',
    },
  ];

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 bg-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal delay={0.1} className="text-center mb-16">
          <div className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold mb-4">
            <HelpCircle className="w-4 h-4" />
            <span>Tire suas dúvidas</span>
          </div>
          <h2
            data-testid="faq-title"
            className="text-3xl md:text-4xl font-bold text-slate-900 mb-4"
          >
            Perguntas frequentes
          </h2>
          <p className="text-lg text-slate-600">
            Ainda com dúvidas? A gente responde tudo sem enrolação aqui embaixo.
          </p>
        </Reveal>

        {/* Accordion */}
        <StaggerGroup staggerDelay={0.1} startDelay={0.2} className="w-full max-w-3xl mx-auto">
          <Accordion type="single" defaultValue="1" collapsible className="w-full">
            {faqs.map((faq) => (
              <StaggerItem key={faq.id}>
                <AccordionItem
                  value={faq.id}
                  data-testid={`faq-item-${faq.id}`}
                  className="border-b border-slate-200 last:border-b"
                >
                  <AccordionTrigger className="text-left pl-4 md:pl-8 overflow-hidden text-slate-600 duration-200 hover:no-underline cursor-pointer py-6 data-[state=open]:text-blue-600 [&>svg]:hidden">
                    <div className="flex flex-1 items-center gap-4 md:gap-6">
                      <p className="text-xs font-mono text-slate-400">{faq.id.padStart(2, '0')}</p>
                      <h3 className="text-lg md:text-xl font-bold tracking-tight">
                        {faq.question}
                      </h3>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 text-sm sm:text-base leading-relaxed pl-12 md:pl-16 pr-4 pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </StaggerItem>
            ))}
          </Accordion>
        </StaggerGroup>
      </div>
    </section>
  );
};
